(function () {
    'use strict';

    function workflowPhase($compile, $http, $log, workflowProcessingService, workflowConfigurationDataService, fileUploadsService) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/workflowPhase.html',
            transclude: true,
            scope: {
                phaseContainer: '=',
                phaseData: '=',
                phaseIndex: '=',
                unskipPhase: '&',
                user: '=',
                updatePhase: '&',
                deleteUpload: '&',
                adminMode: '=',
                editPhaseExtension: '&',
                savePhaseExtension: '&',
                cancelSavePhaseExtension: '&'
            },
            controller: ['$scope', function ($scope) {
                $scope.nextPhaseSummary = {};
                $scope.selectedFiles = [];
                $scope.hasDownloads = false;
                $scope.hasUploads = false;
                $scope.hasQuestions = false;

                $scope.mode = 'Editor';

                $scope.datepickers = [];

                for (var i = 0; i < $scope.phaseData.InformationParts.length; i++) {
                    if ($scope.phaseData.InformationParts[i].ProjectDrawScheduleItems) {
                        for (var j = 0; j < $scope.phaseData.InformationParts[i].ProjectDrawScheduleItems.length; j++) {
                            $scope.datepickers.push(false);
                        }
                    }
                }

                this.datepickerIsOpened = function (index) {
                    return $scope.datepickers[index];
                }

                this.addDatepicker = function () {
                    $scope.datepickers.push(false);
                }

                this.removeDatepicker = function (index) {
                    $scope.datepickers.slice(index, 1);
                }

                this.openDatepicker = function ($event, which) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    $scope.datepickers[which] = true;
                };

                // TODO Move to viewmodel
                var uploaderIndex = 0;
                for (var i = 0; i < $scope.phaseData.InformationParts.length; i++) {
                    if ($scope.phaseData.InformationParts[i].DocumentUploads) {
                        for (var j = 0; j < $scope.phaseData.InformationParts[i].DocumentUploads.length; j++) {
                            if ($scope.phaseData.InformationParts[i].DocumentUploads[j].LinkedTemplateIds.length > 0) {
                                $scope.hasDownloads = true;
                            }

                            $scope.hasUploads = true;
                            $scope.phaseData.InformationParts[i].DocumentUploads[j].uploaderIndex = uploaderIndex;
                            uploaderIndex++;
                        }
                    }

                    if ($scope.phaseData.InformationParts[i].Questions) {
                        $scope.hasQuestions = true;
                    }
                }

                $scope.removeFile = function (index, selectedFile) {
                    fileUploadsService.removeFile(index, selectedFile);
                }

                $scope.$watch(function () { return fileUploadsService.fileUploads }, function (newValue) {
                    $scope.selectedFiles = newValue;
                }, true);

                $scope.adminMode = false;
                $scope.$watch(function () {
                    return workflowProcessingService.adminMode;
                }, function (newValue) {
                    $scope.adminMode = newValue;
                });

                $scope.$watch(function () {
                    return workflowProcessingService.mode;
                }, function (newValue) {
                    if (newValue == "Submit" || newValue == "Skip") {
                        $scope.nextPhaseSummary = workflowProcessingService.getNextPhaseSummary($scope.phaseContainer, $scope.phaseIndex);
                    }
                });

                $scope.showContainerData = function () {
                    $log.debug($scope.phaseContainer);
                }
            }]
        };
    }

    workflowPhase.$inject = ['$compile', '$http', '$log', 'workflowProcessingService',
    'workflowConfigurationDataService', 'fileUploadsService'];

    angular.module('ecap.workflow').directive('workflowPhase', workflowPhase);
})();
